import { render, staticRenderFns } from "./OrdersResale.vue?vue&type=template&id=c7d2e2e2&scoped=true"
import script from "./OrdersResale.vue?vue&type=script&lang=js"
export * from "./OrdersResale.vue?vue&type=script&lang=js"
import style0 from "./OrdersResale.vue?vue&type=style&index=0&id=c7d2e2e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d2e2e2",
  null
  
)

export default component.exports